import {
  ChartBarIcon,
  ChatIcon,
  DotsHorizontalIcon,
  HeartIcon,
  TrashIcon,
} from '@heroicons/react/outline';
import { HeartIcon as HeartIconFilled } from '@heroicons/react/solid';
import {
  collection,
  deleteDoc,
  doc,
  onSnapshot,
  setDoc,
} from 'firebase/firestore';
import Moment from 'react-moment';
import { db, storage } from '../firebase';
import { userState } from '../atom/userAtom';
import { useEffect, useState } from 'react';
import { deleteObject, ref } from 'firebase/storage';
import { useRecoilState } from 'recoil';
import { modalState, postIDState } from '../atom/modalAtom';
import { useRouter } from 'next/router';
export default function Post({ post, id }) {
  const [open, setOpen] = useRecoilState(modalState);

  const [postID, setPostID] = useRecoilState(postIDState);
  const [currentUser] = useRecoilState(userState);

  const router = useRouter();

  async function deletePost() {
    if (window.confirm('Are you sure you want to delete this post?')) {
      deleteDoc(doc(db, 'posts', id));
      if (post.data().image) {
        deleteObject(ref(storage, `posts/${id}/image`));
      }
      router.push('/');
    }
  }
  const [comments, setComments] = useState([]);
  const [likes, setLikes] = useState([]);
  const [hasLiked, setHasLiked] = useState(false);

  useEffect(() => {
    const unsubscribe = onSnapshot(
      collection(db, 'posts', id, 'likes'),
      (snapshot) => setLikes(snapshot.docs)
    );
  }, [db]);

  useEffect(() => {
    const unsubscribe = onSnapshot(
      collection(db, 'posts', id, 'comments'),
      (snapshot) => setComments(snapshot.docs)
    );
  }, [db]);

  useEffect(() => {
    setHasLiked(likes.findIndex((like) => like.id === currentUser?.uid) !== -1);
  }, [likes, currentUser]);

  async function likePost() {
    if (currentUser) {
      if (hasLiked) {
        await deleteDoc(doc(db, 'posts', id, 'likes', currentUser.uid));
      } else {
        await setDoc(doc(db, 'posts', id, 'likes', currentUser.uid), {
          username: currentUser.username,
        });
      }
    } else {
      router.push('/auth/siginin');
    }
  }

  return (
    <div className="flex p-1 cursor-pointer border-b border-gray-400 m-0  select-none hadow-blue-500/50 mb-2   ">
      {/* right side */}
      <div className="flex-1">
        {/* Header */}

        <div className="flex items-center space-x-1  ">
          {/* post user in fo */}

          <img
            className="rounded-full h-11 w-11  ring ring-white-500 ring-offset-1 "
            src={post?.data()?.useImg}
            alt="user-img"
          />

          <div className="flex items-center space-x-2 whitespace-nowrap">
            <h4 className="font-bold text-[15px] sm:text-[16px] hover:underline text-white pl-2">
              {post?.data()?.name}
            </h4>
            <span className="text-sm sm:text-[15px] text-gray-300 ">
              @{post?.data()?.username}{' '}
            </span>

            <span className="text-sm sm:text-[12px] hover:underline text-gray-400 absolute mt-9 ">
              <Moment fromNow>{post?.data()?.timestamp?.toDate()}</Moment>
            </span>
          </div>

          {/* dot icon */}
        </div>

        {/* post text */}

        <p
          onClick={() => router.push(`/posts/${id}`)}
          className="text-white text-[15px sm:text-[16px] mb-3 mt-2"
        >
          {post?.data()?.text}
        </p>

        {/* post image */}

        <img
          onClick={() => router.push(`/posts/${id}`)}
          className="rounded-2xl mr-2    shadow-2xl hadow-blue-500/40          transition ease-in-out delay-50  hover:-translate-y-1 hover:scale-104 duration-300 ..."
          src={post?.data()?.image}
          alt=""
        />

        {/* icons */}

        <div className="flex justify-between text-white p-2 ">
          <div className="flex items-center">
            {hasLiked ? (
              <HeartIconFilled
                onClick={likePost}
                className="h-9 w-9 hoverEffect p-2 text-red-600 hover:bg-red-100"
              />
            ) : (
              <HeartIcon
                onClick={likePost}
                className="h-9 w-9 hoverEffect p-2 hover:text-red-600 hover:bg-red-100"
              />
            )}
            {likes.length > 0 && (
              <span
                className={`${hasLiked && 'text-red-600'} text-sm select-none`}
              >
                {' '}
                {likes.length}
              </span>
            )}
          </div>
          <div className="flex items-center select-none">
            <ChatIcon
              onClick={() => {
                if (!currentUser) {
                  // signIn();
                  router.push('/auth/siginin');
                } else {
                  setPostID(id);
                  setOpen(!open);
                }
              }}
              className="h-9 w-9 hoverEffect p-2 hover:text-sky-500 hover:bg-sky-100"
            />
            {comments.length > 0 && (
              <span className="text-sm">{comments.length} </span>
            )}
          </div>

          <ChartBarIcon className="h-9 w-9 hoverEffect p-2 hover:text-sky-500 hover:bg-sky-100" />
          {currentUser?.uid === post?.data()?.id && (
            <TrashIcon
              onClick={deletePost}
              className="h-9 w-9 hoverEffect p-2 hover:text-red-600 hover:bg-red-100"
            />
          )}
        </div>
      </div>
    </div>
  );
}
